import { render, staticRenderFns } from "./NeedsAttention.vue?vue&type=template&id=1789456b&"
import script from "./NeedsAttention.vue?vue&type=script&lang=js&"
export * from "./NeedsAttention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports